import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import api from "@/lib/api";

const SEEN_KEY = "sc_featured_birthday_seen";

const hasSeenToday = (birthdayId) => {
  try {
    const raw = localStorage.getItem(SEEN_KEY);
    if (!raw) return false;
    const seen = JSON.parse(raw);
    return seen.birthdayId === birthdayId && seen.day === new Date().toDateString();
  } catch (_) {
    return false;
  }
};

const markSeen = (birthdayId) => {
  try {
    localStorage.setItem(SEEN_KEY, JSON.stringify({ birthdayId, day: new Date().toDateString() }));
  } catch (_) {}
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  return new Date(`${dateStr}T00:00:00`).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
  });
};

export const FeaturedBirthdayModal = ({ ready = true }) => {
  const [birthday, setBirthday] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!ready) return;
    let mounted = true;
    api.get("/birthdays/featured").then((res) => {
      if (!mounted) return;
      const list = Array.isArray(res.data) ? res.data : [];
      const next = list[0];
      if (next && !hasSeenToday(next.id)) {
        setBirthday(next);
        window.setTimeout(() => setOpen(true), 600);
      }
    }).catch(() => {});
    return () => { mounted = false; };
  }, [ready]);

  const close = () => {
    setOpen(false);
    if (birthday) markSeen(birthday.id);
  };

  const handleCta = () => {
    close();
    window.setTimeout(() => {
      document.querySelector("#aniversariantes")?.scrollIntoView({ behavior: "smooth" });
    }, 250);
  };

  if (!birthday) return null;

  const imageSrc = birthday.image_data || birthday.image_url || null;
  const event = birthday.event;

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) close(); }}>
      <DialogContent
        className="max-w-md overflow-hidden border-white/10 bg-[#0A0A0A] p-0 sm:max-w-lg"
        data-testid="featured-birthday-modal"
      >
        {imageSrc && (
          <div className="relative aspect-[16/10] w-full overflow-hidden bg-black">
            <img src={imageSrc} alt={birthday.celebrant_name} className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
          </div>
        )}
        <div className="space-y-4 p-6 pt-4">
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-[#C9A45C]/40 bg-[#C9A45C]/10 px-3 py-1.5 text-[0.65rem] font-semibold uppercase tracking-[0.16em] text-[#F4E0B5]">
            Aniversário
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-2xl text-white sm:text-3xl">
            {birthday.celebrant_name}
            {birthday.age ? <span className="ml-2 text-[#C9A45C]">{birthday.age} anos</span> : null}
          </h2>
          {event?.name && (
            <p className="font-['Manrope'] text-sm font-light leading-relaxed text-white/70">
              {event.name}
              {event.date ? ` · ${formatDate(event.date)}` : ""}
            </p>
          )}
          <button
            type="button"
            onClick={handleCta}
            className="hero-cta-premium w-full cursor-pointer px-6 py-3 font-['Manrope'] text-xs uppercase tracking-[0.18em]"
            data-testid="featured-birthday-cta"
          >
            Ver aniversariantes
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
